import { RESET_PAYMENT_GRIDS, SET_PAYMENT_GRIDS } from './actionTypes';
import type { ResetPaymentGridsAction, ScenarioPaymentGrid, SetPaymentGridsAction } from './types';

export const setPaymentGrids = (
    publishedVersion: string,
    scenarios: Record<string, ScenarioPaymentGrid>
): SetPaymentGridsAction => ({
    type: SET_PAYMENT_GRIDS,
    payload: { publishedVersion, scenarios }
});

export const resetPaymentGrids = (): ResetPaymentGridsAction => ({
    type: RESET_PAYMENT_GRIDS
});
